import { BrowserCacheLocation } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_UDM_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_UDM_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_PUBLIC_URL,
    postLogoutRedirectUri: process.env.REACT_APP_PUBLIC_URL
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage
  }
};

export const apiRequest = {
  scopes: [
    `api://${process.env.REACT_APP_API_CLIENT_ID}/api.read`,
    `api://${process.env.REACT_APP_API_CLIENT_ID}/api.write`
  ]
};

export const API_BASE_URL = process.env.REACT_APP_UDM_API_URL;